import { render, staticRenderFns } from "./ScsSearchSelectTag.vue?vue&type=template&id=70f65c0e&scoped=true&"
import script from "./ScsSearchSelectTag.vue?vue&type=script&lang=js&"
export * from "./ScsSearchSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f65c0e",
  null
  
)

export default component.exports